export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVPAVaria';
export const NAME = 'ZarazeniVozidlaPujcovny';
